const CampaignSkeletonLoader = () => {
    return (
        <>
            <div className="h-16 md:h-28 bg-gray-300 animate-pulse"></div>
            <div className="flex flex-col lg:flex-row w-full justify-center items-start md:py-6 gap-5 md:px-[3.5rem] px-4 py-4">
                <div className="w-full lg:w-[65%] xl:w-[70%] order-1 space-y-6">
                    <div className="h-64 md:h-[70vh] bg-gray-300 animate-pulse rounded"></div>
                    <div className="flex justify-between">
                        <div className="h-4 w-24 bg-gray-300 animate-pulse rounded"></div>
                        <div className="h-4 w-24 bg-gray-300 animate-pulse rounded"></div>
                    </div>
                    <div className="h-8 w-3/4 bg-gray-300 animate-pulse rounded"></div>
                    <div className="space-y-2">
                        <div className="h-4 w-full bg-gray-300 animate-pulse rounded"></div>
                        <div className="h-4 w-5/6 bg-gray-300 animate-pulse rounded"></div>
                        <div className="h-4 w-4/6 bg-gray-300 animate-pulse rounded"></div>
                    </div>
                    {[1, 2].map((item) => (
                        <div key={item} className="space-y-4 pt-6 border-t border-gray-200">
                            <div className="grid grid-cols-2 gap-4">
                                <div className="aspect-square bg-gray-300 animate-pulse rounded"></div>
                                <div className="aspect-square bg-gray-300 animate-pulse rounded"></div>
                            </div>
                            <div className="h-6 w-1/2 bg-gray-300 animate-pulse rounded"></div>
                            <div className="space-y-2">
                                <div className="h-4 w-full bg-gray-300 animate-pulse rounded"></div>
                                <div className="h-4 w-5/6 bg-gray-300 animate-pulse rounded"></div>
                                <div className="h-4 w-3/4 bg-gray-300 animate-pulse rounded"></div>
                            </div>
                        </div>
                    ))}
                    <div className="h-64 bg-gray-300 animate-pulse rounded"></div>
                </div>
                <div className="w-full lg:w-[35%] xl:w-[30%] order-2 lg:order-1 space-y-4">
                    <div className="h-96 bg-gray-300 animate-pulse rounded"></div>
                    <div className="h-32 bg-gray-300 animate-pulse rounded"></div>
                    <div className="h-48 bg-gray-300 animate-pulse rounded"></div>
                </div>
            </div>
        </>
    );
};

export default CampaignSkeletonLoader;